<template>
  <div class="stories">
    <background :item="item" :theme="theme" />
  </div>
</template>

<script>
import editingMixins from '../../../../mixins/editing-mixins';
import BackgroundComponent from '../../shared/Background.vue';

export default {
  mixins: [editingMixins],
  components: {
    background: BackgroundComponent,
  },
  created() {
    if (!this.item.fields) {
      this.$set(this.item, 'fields', {});
    }
  },
};
</script>
